module.exports = __webpack_public_path__ + "img/quality.af00472.webp";